import { ReactNode } from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface ContentCardProps {
  title?: ReactNode;
  description?: string;
  children: ReactNode;
  headerContent?: ReactNode;
  className?: string;
  contentClassName?: string;
}

export function ContentCard({
  title,
  description,
  children,
  headerContent,
  className,
  contentClassName,
}: ContentCardProps) {
  return (
    <Card className={cn("w-full max-w-md mx-auto", className)}>
      <CardHeader className="space-y-2">
        {headerContent ? (
          headerContent
        ) : title ? (
          <div className="flex items-center space-x-2">
            <h2 className="text-2xl font-bold">{title}</h2>
          </div>
        ) : null}
        
        {description && (
          <p className="text-sm text-muted-foreground">
            {description}
          </p>
        )}
      </CardHeader>

      <CardContent className={cn("space-y-6", contentClassName)}>
        {children}
      </CardContent>
    </Card>
  );
} 